import { KEY_ORDER_ID
    , KEY_TECH_ID
    , MFACTION_SET_VARIABLE
    , MFACTION_TAG
    , MFACTION_NEW_PAGE_VIEW } 
    from '../constants/mouseFlow';

export const setOrderId = (orderId) => {
    window._mfq = window._mfq || [];
    window._mfq.push([MFACTION_SET_VARIABLE, KEY_ORDER_ID, orderId]);
};

export const setTechId = (techId) => {
    window._mfq = window._mfq || [];
    window._mfq.push([MFACTION_SET_VARIABLE, KEY_TECH_ID, techId]);
};

export const setTag = (tagName) => {
    window._mfq = window._mfq || [];
    window._mfq.push([MFACTION_TAG, tagName]);
};

export const setNewPageView = (url) => {
    window._mfq = window._mfq || [];
    window._mfq.push([MFACTION_NEW_PAGE_VIEW, url]);
};


// WEBPACK FOOTER //
// ./src/utils/mouseFlowUtils.js